import { D as DialogExt } from './dialog-YICKoIDv.js';
import './focus-trap.esm-MYAhwz8v.js';
import './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class DrawerElement extends DialogExt {
  #windowWidthOnOpen = 0;
  #eventController = null;

  open() {
    this.#windowWidthOnOpen = window.innerWidth;
    // Call super first to run the logic in the parent class
    super.open();

    // Close the drawer when the window is resized in width.
    this.#eventController?.abort();
    this.#eventController = new AbortController();

    window.addEventListener('resize', () => this.onResize(), {
      signal: this.#eventController.signal,
    });
  }

  close() {
    super.close();
    this.#eventController?.abort();
  }

  disconnectedCallback() {
    this.#eventController?.abort();
  }

  onResize() {
    if (window.innerWidth !== this.#windowWidthOnOpen) {
      super.close();
      this.#eventController?.abort();
    }
  }
}

customElements.define('drawer-element', DrawerElement);
